<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  },
  mounted(){
    if (this._isMobile()) {
      window.open('http://m.shengxuebao.cn/login', '_self')
    }
  }
}
</script>

<style>
.container{
  width: 1200px;
  margin:0 auto;
}
.themecolor{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #009365!important;
  line-height: 22px;
  cursor: pointer;
}
.redcolor{
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ED4141!important;
  line-height: 22px;
}
/* webkit内核的浏览器滚动条定制 */
.scrollbar::-webkit-scrollbar{ /* 滚动条宽 */
  width:8px;
  height:12px;
}
.scrollbar::-webkit-scrollbar-track{ /* 滚动条背景槽 */
  background: #E3E8EB;
  border-radius:3px;
}
.scrollbar::-webkit-scrollbar-track-piece{/*内层轨道，滚动条中间部分*/
  border-radius: 3px 3px 0px 0px;
}
.scrollbar::-webkit-scrollbar-thumb{ /* 滚动条 拖动条 */
  background:rgba(196, 201, 205, 1);
  border-radius:3px;
}
.scrollbar::-webkit-scrollbar-thumb:hover{
  background: #c0c6c9;
}
.scrollbar::-webkit-scrollbar-corner{ /* 边角，即两个滚动条的交汇处 */
  background: #f6f6f6;
}
/* 修改默认滚动条样式 end*/

/* webkit内核的浏览器滚动条定制 */
.scrollbar2::-webkit-scrollbar{ /* 滚动条宽 */
  width:4px;
  height:12px;
}
.scrollbar2::-webkit-scrollbar-track{ /* 滚动条背景槽 */
  background: #E3E8EB;
  border-radius:3px;
}
.scrollbar2::-webkit-scrollbar-track-piece{/*内层轨道，滚动条中间部分*/
  border-radius: 3px 3px 0px 0px;
}
.scrollbar2::-webkit-scrollbar-thumb{ /* 滚动条 拖动条 */
  background:rgba(196, 201, 205, 1);
  border-radius:3px;
}
.scrollbar2::-webkit-scrollbar-thumb:hover{
  background: #c0c6c9;
}
.scrollbar2::-webkit-scrollbar-corner{ /* 边角，即两个滚动条的交汇处 */
  background: #f6f6f6;
}
/* 修改默认滚动条样式 end*/
</style>



// WEBPACK FOOTER //
// src/App.vue